module.exports = __webpack_public_path__ + "img/branch-beijing.88b4955b.jpg";